import { Reveal, Chapter } from "./Reveal";

const ASPHALT =
  "https://images.pexels.com/photos/14658667/pexels-photo-14658667.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const TERMS = [
  "Offer applicable only for exclusive online registered customers.",
  "Valid on the purchase of 4 car tyres in a single invoice at Tyre Empire, Bengaluru.",
  "Choose one reward: a tyre inflator worth ₹4,000 or an Amazon shopping voucher worth ₹2,000. Rewards are subject to availability.",
  "Tyre Empire reserves the right to modify or withdraw this offer without prior notice.",
];

const BRANDS = [
  "Bridgestone", "MRF", "Michelin", "Yokohama", "Apollo",
  "Continental", "Goodyear", "Pirelli", "Ceat", "JK Tyres",
];

export default function TermsSection() {
  return (
    <section id="terms" data-testid="terms-section" className="relative border-t border-white/10 py-24 md:py-32">
      <img
        src={ASPHALT}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover opacity-20 grayscale"
      />
      <div className="absolute inset-0 bg-black/70" aria-hidden />
      <div className="relative mx-auto grid max-w-7xl gap-16 px-6 md:px-12 lg:grid-cols-2">
        <Reveal>
          <Chapter number="04" title="Terms & Conditions" />
          <h2 className="font-display text-4xl uppercase tracking-tight text-white sm:text-5xl">
            The fine print
          </h2>
          <ol className="mt-10 space-y-6" data-testid="terms-list">
            {TERMS.map((term, i) => (
              <li key={term} className="flex items-start gap-5 border-b border-white/10 pb-6">
                <span className="font-display text-2xl text-[#FF3B30]">0{i + 1}</span>
                <span className="text-sm leading-relaxed text-white/70 md:text-base">{term}</span>
              </li>
            ))}
          </ol>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-[#FFCC00]">
            Eligible Tyre Brands
          </p>
          <h3 className="mt-4 font-display text-3xl uppercase text-white">
            10 brands. One offer.
          </h3>
          <div className="mt-10 flex flex-wrap gap-3" data-testid="brands-list">
            {BRANDS.map((brand) => (
              <span
                key={brand}
                className="cursor-default border border-white/15 px-5 py-2.5 font-heading text-xs font-semibold uppercase tracking-[0.2em] text-white/70 transition-colors duration-300 hover:border-[#FF3B30] hover:text-[#FF3B30]"
              >
                {brand}
              </span>
            ))}
          </div>
          <p className="mt-10 max-w-sm text-sm text-white/50">
            Offer applies only to the brands listed above. Ask our store team for the full range in
            stock for your vehicle.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
